/**
 * Created by yougen.zhuangyg on 2014/6/13.
 */


    var $ = require('@alife/alpha-jquery/jquery'),
        Base = require('@alife/alpha-base/base'),
        I18N = require('./i18n') || require('./i18n')._('en-us'),
        Lang = require('../common/lang.js'),
        Validator = require('@alife/alpha-validator/validator'),
        Handlebars = require('@alife/alpha-handlebars/handlebars'),
        PrivacyCard = require("../common/privacy-card.js"),
        SecurityCode = require("../common/security-code.js"),
        Dialog = require('@alife/alpha-dialog/dialog.js'),
        CookieInfo = require('@alife/alpha-cookie-info/cookie-info.js'),
        InquirySend = require('../common/inquiry-send.js'),
        ExchangeMessage = require("../common/exchange-message"),
        Token = require("../common/token"),
        FeedBackInquiryContentTmpl = require('./fast-feed-inquiry-content.tpl'),
        FeedBackResultTmpl = require('./fast-feed-inquiry-result.tpl'),
        contentBalloonTmpl = require('./content-balloon.tpl'),
        IfmForward = require('../common/ifm-forward/ifm-forward');

    var domdot = require('@alife/alpha-domdot/domdot');
    //Handlerbars的helper是全局的, 会覆盖同名helper
    Handlebars.registerHelper('I18N4FB', function(key) {
        if (key) {
            return I18N.app[key] || '';
        }
        return '';
    });

    Handlebars.registerHelper('compare', function(lvalue, operator, rvalue, options) {
        var operators, result;

        if (arguments.length < 3) {
            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
        }

        if (options === undefined) {
            options = rvalue;
            rvalue = operator;
            operator = "===";
        }

        operators = {
            '==' : function(l, r) {
                return l == r;
            },
            '===' : function(l, r) {
                return l === r;
            },
            '!=' : function(l, r) {
                return l != r;
            },
            '!==' : function(l, r) {
                return l !== r;
            },
            '<' : function(l, r) {
                return l < r;
            },
            '>' : function(l, r) {
                return l > r;
            },
            '<=' : function(l, r) {
                return l <= r;
            },
            '>=' : function(l, r) {
                return l >= r;
            },
            'typeof' : function(l, r) {
                return typeof l == r;
            }
        };

        if (!operators[operator]) {
            throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
        }

        if ( typeof rvalue === 'string' && rvalue.indexOf('||') !== -1) {
            result = false;
            $.each(rvalue.split('||'), function(i, rvalue) {
                result = (result || operators[operator](lvalue, rvalue));
            });
        }
        else if ( typeof rvalue === 'string' && rvalue.indexOf('&&') !== -1) {
            result = true;
            $.each(rvalue.split('&&'), function(i, rvalue) {
                result = (result && operators[operator](lvalue, rvalue));
            });
        }
        else {
            result = operators[operator](lvalue, rvalue);
        }

        if (result) {
            return options.fn(this);
        }
        else {
            return options.inverse(this);
        }
    });


    var baseUrl = "//message.alibaba.com",
        URLS = {
            COMPANY_INFO: '/msgsend/companyInfo.htm',
            PRODUCT_INFO: '/msgsend/productInfo.htm',
            ABANDON: '/msgsend/sendAbandon.htm',
            SEND_INQUIRY: '/msgsend/contact.htm?action=ajaxFormSendInquiryAction&iframe_delete=true',
            SUCCEE: '/msgsend/feedbackInquirySucess.htm',
            FAIL: '/msgsend/errorMessage.htm'
        };
    var FastFeedbackInquiry = Base.extend({
        initialize: function(config){
            FastFeedbackInquiry.superclass.initialize.call(this,config);
            //控制自动发送请求
            if(config.autoFetch !== false) {
                this.fetchData();
            }
            // dot(26960,getExt({status:'init'}));
        },
        attrs: {
            container: 'body',
            sourceID: '',// product id 或 company id
            sourceID_f: '',// 加密id
            appFrom: 's_en',//语言来源
            sceneId: 'detail',//布点来源, 目前有detail和minisite
            domain: 1,// 1表示对产品发询盘，2表示对公司
            bizType: 2,// 表示通过直通车发询盘
            popup: 0, //历史遗留
            language: '',//指定特定语言,接口返回的字段就以该语言为准
            mloca: "car_other",//询盘发起埋点位置
            _host_token_: '',
            _csrf_token_: '', // 请求接口时用
            umidToken: '',//风控需要
            ext: '', // 额外标识
            subscribe: null, // 只有主站detail需要这个订阅
            autoFetch: null
        },
        fetchData: function(){
            var inquiryProduct = this.get('domain') == 1,
                secToken,
                tokenKey,// 旺铺使用_host_token_,其余用_csrf_token_
                id = inquiryProduct ? "productId" : "companyId",
                id_f = inquiryProduct ? "productId_f": "companyId_f",
                quiryData = {},self = this,url;
            quiryData[id] = this.get('sourceID');
            quiryData[id_f] = this.get('sourceID_f');
            url = this.get('domain') == 1 ? URLS.PRODUCT_INFO: URLS.COMPANY_INFO;
            if(this.get('_csrf_token_')){
                tokenKey = "_csrf_token_";
                secToken = this.get('_csrf_token_');
            }else {
                tokenKey = "_host_token_";
                secToken = this.get('_host_token_');
            }
            quiryData[tokenKey] = secToken;
            //如果传了该值,则返回字段值以该语言为准
            if(this.get('language')){
                url += "?globalFeedbackLanguage=" + this.get('language');
                var lang = Lang(this.get('language'));
                this.lang = lang;
                I18N = require('./i18n')._(lang) || I18N;
            }
            // 开始请求数据请,对页面做个loading...状态
            this.container = $(this.get('container'));
            this.container.html('<div class="ui-fastfb-loading"><i></i>loading...</div>');
            $.ajax({
                dataType: 'jsonp',
                url: baseUrl + url,
                data: quiryData,
                success: function(result){
                    self.renderUI(result);
                    var loginStatus = CookieInfo.getIsLoggedIn() ? 'initlogined' : 'initnologin';
                    domdot.dotstat(26960, {ext:'ztc=1|status=' + loginStatus});
                    // dot(26960,getExt({status:loginStatus}));
                }
            });
        },
        renderUI: function(result){
            this.data = result.data;
            if(this.data){
                this.data.isLogin = CookieInfo.getIsLoggedIn();
                this.data.isProductInquiry = this.get('domain') == 1;
                InquirySend.initSecurityData(this.data);
                var formContent = Handlebars.compile(FeedBackInquiryContentTmpl)(this.data);
                //数据请求完毕, 展示真实数据
                this.container.html(formContent);
                this.form = this.container.find('[data-role=fast-feed-form]');
                this.form.attr("action", baseUrl + URLS.SEND_INQUIRY);
                this.toRfq = this.form.find('[data-role=to-rfq]');
                this.toPrivacy = this.form.find('[data-role=to-privacy]');
                this.loginEl = this.form.find('[data-role=from]');
                this.content = this.form.find('[data-role=inquiry-content]');
                this.data.language = this.lang || 'en-us';

                if(!!this.data.isProductInquiry){
                    this.quantityUnit = this.form.find("[data-role=quantityUnit]");
                    this.quantityNumber = this.form.find("[data-role=quantityNumber]");
                }
                //focus dot, 直通车统计C-F
                this.form.find('[data-role=quantityNumber],[data-role=from],[data-role=inquiry-content]').one('focus', function() {
                    if(this.isFocus){
                        return;
                    }
                    //区分旺铺和detail
                    this.dotSceneId();
                    this.isFocus = true;
                    domdot.dotstat(26960, {ext:'ztc=1|status=focus'});
                }.bind(this));
                this.toRfq.on("click", function(){
                    dot(2430);
                });
                this.bindUI();
                new PrivacyCard({
                    data: this.data,
                    trigger: this.form.find("[data-role=privacy-tip]")
                }).renderCard();
                //兼容多语言布点
                this.container.css("overflow","hidden");
                this.checkCode = new SecurityCode({
                    el: this.form.find("[data-role=check-code-element]")
                });
                this.validate();
                // TODO: 暂时隐藏推荐
            }
        },
        //是否英文站点
        isEnglish: function(){
            return this.get('appFrom') == 's_en';
        },
        //根据布点打点
        dotSceneId: function(){
            var ext = getExt(this.get('ext'));
            if(this.get("sceneId") == "detail"){
                dot(3304, ext);
            }else {
                dot(3614, ext);
            }
        },
        bindUI: function() {
            var self = this;
            //旺铺和主站区分,多语言不需要balloon
            if(this.isEnglish()){
                if(this.get("sceneId") == 'minisite'){
                    this.content.one("click", function(){
                        self.content.parent("[data-role=content-container]").addClass("content-container-snoop");
                        self.renderBalloon();
                    });
                }else {
                    self.content.parent("[data-role=content-container]").addClass("content-container-snoop");
                    self.renderBalloon();
                }
            }
            // this.content.focus(function() {
            //     if(!CookieInfo.getIsLoggedIn() && !CookieInfo.getFirstName()) {
            //         dot(17340, 'ext=NoLoginNoMemberFocus');
            //     }
            //     if(CookieInfo.getIsLoggedIn()) {
            //         dot(17345, 'ext=LoginFocus');
            //     }
            // });
            this.form.on("click", "[data-cmd=check-code-refresh]", function(){
               self._refreshCode();
            });
        },
        _refreshCode: function(){
           if(this.checkCode){
               this.checkCode.refresh();
           }
        },
        //使用Balloon组件有bug, 组件可能还没有撑开, 导致balloon定位不准
        //在第一次点击content时再显示balloon
        renderBalloon: function(){
            var content = Handlebars.compile(contentBalloonTmpl)();
            var ballonHtml = '<div class="ui2-balloon ui2-balloon-lt">'+
                content +
                '</div>';

            $(ballonHtml).appendTo(this.form.find("[data-role=content-container]"));
        },
        send:function(){
            if(CookieInfo.getIsLoggedIn()){ // 不要用this.data.isLogin
                domdot.dotstat(26960, {ext:'ztc=1|status=submitlogined'});
                this.commit();
                return this;
            }
            domdot.dotstat(26960, {ext:'ztc=1|status=submitnologin'});
            var inquirySend = new InquirySend({
                loginId: this.loginEl.val(),
                email: this.data.email,
                callback: {fn: this.commit, context: this}
            });

            inquirySend.checkEmail({
                bizScenes: 'fast-feedback',
                noalibaba: false
            });
        },
        setFormData: function(){
            this.form.find("input[data-role=domain]").val(this.get('domain'));
            this.form.find("input[data-role=pageId]").val(window.dmtrack_pageid);
            this.form.find("input[data-role=id]").val(this.get('sourceID'));
            this.form.find("input[data-role=id_f]").val(this.get('sourceID_f'));
            this.form.find("input[data-role=appFrom]").val(this.get('appFrom'));
            this.form.find("input[data-role=bizType]").val(this.get('bizType'));
            this.form.find("input[data-role=popup]").val(this.get('popup'));
            this.form.find("input[data-role=mloca]").val(this.get('mloca'));
            this.form.find("input[data-role=umidToken]").val(this.get('umidToken'));
            //form表单默认在checkbox勾选后值为on
            if(this.data.isProductInquiry) {
                this.form.find("input[data-role=toRfq]").val(this.toRfq.prop("checked"));
                this.form.find("input[data-role=quantityValue]").val(this.quantityNumber.val() + ' ' + this.quantityUnit.val());
            }else {
                this.form.find("input[data-role=toRfq]").val(false);
                this.form.find("input[data-role=quantityValue]").val('');
            }
            this.form.find("input[data-role=sendCard]").val(this.toPrivacy.prop("checked"));
            var token = Token.getToken();
            if(token){
                this.form.find("input[data-role=ctoken]").val(token);
            }else {
                var hostToken = this.get('_host_token_');
                this.form.find("input[data-role=_host_token_]").val(hostToken);
            }
            /*if(this.transfer.prop('checked')) {
                var companyList = JSON.stringify({companyList: this.getForwardData()});
                this.form.find('input[data-role=forwardCompanyList]').val(companyList);
            }*/
            this.serializeSecCode();
        },
        getForwardData: function() {
            var forwardItems = this.container.find('[data-role=forward-company]');
            var companyList = [];
            if(forwardItems.length) {
                forwardItems.each(function() {
                    companyList.push({
                        companyId: $(this).attr('data-company-id'),
                        productId: $(this).attr('data-product-id')
                    });
                });
            }
            return companyList;
        },
        serializeSecCode: function(){
            var secData = this.checkCode.getPostData();
            for(var key in secData){
                this.form.find("input[data-role=" + key + "]").val(secData[key]);
            }
        },
        commit: function(){
            if(this.checkCode.validate()){
                this.setFormData();
                new ExchangeMessage(this.showResult, this, this.form);
                //原始表单提交
                this.form[0].submit();
            }else {
                this.checkCode.show();
            }
        },
        showResult: function(data){
            data.success = (data.code == 200 || data.code == 7001);
            domdot.dotstat(26960, {ext:'ztc=1|status=sendSuccess'});
            // var url,sceneId,memSeq,secTradeId,promptShareCard;

            // sceneId = data.data && data.data.sceneId;
            // memSeq = data.data && data.data.aliMemberId;
            // secTradeId = data.data && data.data.secTradeId;
            // var sendCard = this.toPrivacy && this.toPrivacy.prop("checked");
            // promptShareCard = sendCard === false;

            // url = baseUrl + URLS.SUCCEE;
            // if(this.data.isProductInquiry) {
            //     url += "?productIds=" + this.get('sourceID');
            // } else {
            //     url += "?aliMemberId=" +  memSeq;
            // }

            // url += "&sceneId=" + sceneId + '&promptShareCard=' + promptShareCard;
            // window.location = url;

            data.rfqTarget = getRfqTarget();
            if(this.data.isProductInquiry){
                data.rfqTarget += "&productId=" + this.get('sourceID');
            }else {
                data.rfqTarget += "&companyId=" + this.get('sourceID');
            }

            var content = Handlebars.compile(FeedBackResultTmpl)(data);
            new Dialog({
                content: content,
                hasMask: false,
                width: 610,
                events : {
                    'click [data-role=close]' : function() {
                        this.destroy();
                    }
                }
            }).show();
        },
        switchSuceess: function() {

        },
        validate: function(){
            var validator = new Validator({
                element : this.form,
                autoSubmit : false,
                itemSelector: '.ui2-form-control',
                errorParentSelector: '.ui2-form-control'
            }), self = this;

            validator.addItem({
                element: this.content,
                required: true,
                rule: 'minlength{min:20} maxlength{max:8000}',
                errormessageRequired: I18NUtil('feedback.msgsend.control.msgContent.msg.must'),
                errormessageMinlength: I18NUtil('feedback.msgsend.control.msgContent.msg.char.limit'),
                errormessageMaxlength: I18NUtil('feedback.msgsend.control.msgContent.msg.char.limit'),
                onItemValidated: function(err, msg) {
                    if(err) {
                        domdot.dotstat(26960, {ext:'ztc=1|status=contentValidateError'});
                    }
                }
            });

            if(this.data.isProductInquiry){
                validator.addItem({
                    element: this.quantityNumber,
                    rule: 'number',
                    errormessageNumber: I18NUtil('feedback.msgsend.control.msgQuantity.limit.number'),
                    onItemValidated: function(err, msg) {
                        if(err) {
                            domdot.dotstat(26960, {ext:'ztc=1|status=quantityValidateError'});
                        }
                }
                });
            }

            validator.off("formValidated").on('formValidated', function(err, result, elem) {
                domdot.dotstat(26960, {ext:'ztc=1|status=submit'});
                if (!err) {
                    domdot.dotstat(26960, {ext:'ztc=1|status=validated'});
                    this.send();
                } else {
                    domdot.dotstat(26960, {ext:'ztc=1|status=validateError'});
                }
            }.bind(this));
        }
    });

    // util functions
    function I18NUtil(key){
        return I18N.app[key] || '';
    }

    function dot(cid, params) {
        if (window['dmtrack']) {
            params = params ? params + '|ztc=1' : 'ext=ztc=1';
            window.dmtrack.dotstat(cid, params);
        }
    }

    function getExt(ext){
        if(!ext){
            return "";
        }
        var param = [];
        for(var key in ext) {
            param.push(key + "=" + ext[key]);
        }
        param = param.join("|");
        return param ? "ext=" + param: "";
    }

    function getRfqTarget() {
        /**
         * th_TH, thai
         * vi_VN vietnamese
         * tr_TR turkish
         * ar_SA arabic
         * en_US english
         */
        /*var targetHref =
            {   'es_ES': 'http://us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=spanish&tracelog=es-inquiry-success',
                'pt_PT': 'http://us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=portuguese&tracelog=pt-inquiry-success',
                'fr_FR': 'http://us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?french&tracelog=fr-inquiry-success',
                'ru_RU': 'http://us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=russian&tracelog=ru-inquiry-success  ',
                'ja_JP': 'http://us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=japanese&tracelog=ja-inquiry-success',
                'de_DE': 'http://us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=german&tracelog=de-inquiry-success',
                'it_IT': 'http://us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=italian&tracelog=it-inquiry-success',
                'ko_KR': 'http://us.sourcing.alibaba.com/rfq/request/post_buy_request.htm?language=korean&tracelog=ko-inquiry-success',
                'other': 'http://rfq.alibaba.com/form.htm?tracelog=inquiry_detail_RFQ_201406'
            },
            locale = CookieInfo.getLocale();
        return targetHref[locale] || targetHref["other"];*/
        return "//rfq.alibaba.com/rfq/post.htm?tracelog=inquiry_detail_RFQ_201406";
    }

    module.exports = FastFeedbackInquiry;
